import { Box, Link, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import "../../../CommonScss/QuotePage.scss";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import RKTextField from "../../../Components/Common/FieldTypes/RKTextField/RKTextField";
import GreyBoxTitle from "../../../Components/Desktop/GreyBoxTitle/GreyBoxTitle";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../../shared/Path";

function TravelInformation() {
  const navigate = useNavigate();
  const [file, setFile] = React.useState("");
  const [fileOne, setFileOne] = React.useState("");
  const [formFields, setFormFields] = useState<{
    fullName: { value: string; warning: boolean };
  }>({
    fullName: { value: "", warning: false },
  });

  const updateMasterState = (attrName: any, value: any) => {
    attrName[3]({
      ...attrName[2],
      [attrName[0]]: { ...[attrName[0]], [attrName[1]]: value },
    });
  };

  function handleChange(e: any) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  function handleChangeClick(e: any) {
    console.log(e.target.files);
    setFileOne(URL.createObjectURL(e.target.files[0]));
  }
  return (
    <Box className="quoteWrapper">
      <QuoteNavbar />
      <Grid container spacing={3}>
        <Grid xs maxWidth="300px">
          <div className="ctaBtn mb-4">
            <CustomButton
              class_name="backBtn"
              text_name="Back"
              onClickFunction={() => {
                navigate(-1);
              }}
            />
          </div>
          <Box className="lefSidebar">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div>
                <p>Travellers:</p>
                <h6>4 Members</h6>
              </div>
              <div>
                <p>Travelling to:</p>
                <h6>England, Canada</h6>
              </div>
              <div>
                <p>Departure on:</p>
                <h6>Dec 6, 2023</h6>
              </div>
              <div>
                <p>Return on:</p>
                <h6>Dec 26, 2023</h6>
              </div>
            </div>
            <Box className="whiteBox">
              <p
                style={{
                  borderBottom: "1px solid #6458D8",
                  marginBottom: "12px",
                }}
              >
                Worldwide Travel Policy
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h5
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#6458D8",
                  }}
                >
                  ₹ 1,024
                </h5>
                <p>+ Taxes</p>
              </div>
            </Box>
          </Box>
        </Grid>
        <Grid xs>
          <>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <GreyBoxTitle title="Travel Information" />
              </Grid>
              <Grid xs={12} marginBottom={"10px"}>
                <h6
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#6458D8",
                  }}
                >
                  What is your route of travel?
                </h6>
              </Grid>
            </Grid>

            {/* If Yes */}
            <Grid container spacing={3}>
              <Grid xs={8}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"What is your purpose of travel?"}
                  value={formFields.fullName.value}
                  attrName={["fullName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.fullName.warning}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3} marginBottom={"24px"}>
              <Grid xs={6}>
                <Box marginBottom={"24px"}>
                  <h5 style={{ fontWeight: "600", marginBottom: "24px" }}>
                    Henry
                  </h5>
                  <h6 style={{ fontWeight: "500", fontSize: "12px" }}>
                    Passport *
                  </h6>
                </Box>
                <Box className="upload_file">
                  <span>
                    {" "}
                    <img
                      src="./images/upload_dummy_img.svg"
                      alt=""
                      className="logo"
                    />
                  </span>
                  <Link component="label">
                    {" "}
                    <input
                      hidden
                      accept="text/*"
                      multiple
                      type="file"
                      onChange={handleChange}
                    />
                    {file.length > 0 ? file : " Choose File"}
                  </Link>
                </Box>
              </Grid>
              <Grid xs={6}>
                <Box marginBottom={"24px"}>
                  <h5 style={{ fontWeight: "600", marginBottom: "24px" }}>
                    Jennifer
                  </h5>
                  <h6 style={{ fontWeight: "500", fontSize: "12px" }}>
                    Passport *
                  </h6>
                </Box>
                <Box className="upload_file">
                  <span>
                    {" "}
                    <img
                      src="./images/upload_dummy_img.svg"
                      alt=""
                      className="logo"
                    />
                  </span>
                  <Link component="label">
                    {" "}
                    <input
                      hidden
                      accept="text/*"
                      multiple
                      type="file"
                      onChange={handleChangeClick}
                    />
                    {fileOne.length > 0 ? file : " Choose File"}
                  </Link>
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn" display={"flex"}>
                <Box marginRight={"24px"}>
                  {" "}
                  <CustomButton
                    class_name="whiteXlBtn"
                    text_name="Email Quote"
                  />
                </Box>
                <CustomButton
                  onClickFunction={() => {
                    navigate(PATH.PREVIEW_PAGE);
                  }}
                  text_name="Continue"
                  class_name="blueXlBtn"
                />
              </Grid>
            </Grid>
          </>
        </Grid>
      </Grid>
    </Box>
  );
}

export default TravelInformation;
